
export const landing = {
  hero: {
    title: "Reduce las Malas Contrataciones en un 73%",
    subtitle: "Toma decisiones de contratación basadas en datos con evaluaciones científicamente validadas. Únete a más de 10,000 equipos que han mejorado el rendimiento y construido equipos más fuertes.",
    cta: "Comenzar Evaluación",
    trusted: "Confiado por empresas Fortune 500",
    noCard: "No se requiere tarjeta de crédito",
    fastResults: "Resultados en 10 minutos"
  },
  companies: {
    title: "Confiado por líderes de la industria mundial"
  },
  stats: {
    assessments: "50K+",
    assessmentsLabel: "Evaluaciones Completadas",
    reduction: "73%",
    reductionLabel: "Reducción en Malas Contrataciones",
    rating: "4.9",
    ratingLabel: "Calificación de Clientes"
  },
  customerSuccess: {
    title: "Resultados Reales de Equipos Reales",
    subtitle: "Únete a miles de organizaciones usando nuestra plataforma para construir equipos más fuertes y efectivos",
    metrics: {
      performance: {
        value: "89%",
        label: "Mejora en el Rendimiento del Equipo",
        description: "Los equipos reportan mejor colaboración"
      },
      professionals: {
        value: "10,000+",
        label: "Profesionales Evaluados",
        description: "En más de 500 empresas"
      },
      satisfaction: {
        value: "4.9/5",
        label: "Satisfacción del Cliente",
        description: "Basado en más de 2,000 reseñas"
      },
      time: {
        value: "10 min",
        label: "Tiempo Promedio de Finalización",
        description: "Insights rápidos y accionables"
      }
    }
  },
  howItWorks: {
    title: "Cómo Funciona",
    subtitle: "Obtén insights accionables en 3 pasos simples",
    steps: {
      assess: {
        title: "Comenzar Evaluación",
        description: "Completa nuestras evaluaciones comportamentales y cognitivas científicamente validadas en menos de 30 minutos."
      },
      results: {
        title: "Obtener Resultados",
        description: "Recibe perfiles detallados de personalidad, habilidades cognitivas y preferencias de estilo de trabajo con gráficos visuales."
      },
      decisions: {
        title: "Tomar Decisiones",
        description: "Usa insights para contratación, formación de equipos, planificación de desarrollo y colaboración mejorada."
      }
    }
  },
  features: {
    title: "¿Por Qué Elegir Nuestra Plataforma?",
    subtitle: "Evaluaciones respaldadas por la ciencia que entregan resultados reales"
  },
  testimonials: {
    title: "Lo Que Dicen Nuestros Clientes",
    subtitle: "Escucha de líderes que han transformado sus equipos con nuestra plataforma"
  },
  finalCta: {
    title: "¿Listo para Transformar tu Contratación?",
    subtitle: "Únete a más de 10,000 equipos usando nuestra plataforma para tomar mejores decisiones de contratación y construir equipos más fuertes.",
    cta: "Comenzar Evaluación Ahora",
    features: {
      noCard: "No se requiere tarjeta de crédito",
      compliant: "Compatible con GDPR",
      fast: "Resultados en 10 minutos"
    }
  }
};
